import { set } from "lodash";

export class ReportingWorkarea extends HTMLElement
{
    constructor()
    {
        super();
    }

    connectedCallback() 
    {
        this.init();
    }

    init()
    {
        this.loadEventHandlers();
        this.setPrintButtonState();
    }

    setPrintButtonState()
    {
        const activeAiReport = this.querySelector('.ai-report.active');
        if (activeAiReport) {
            const activeReportContainer = activeAiReport.closest('.reports-container');
            if (activeReportContainer) {
                const activeCaseID = activeReportContainer.dataset.case_id;
                const printBtn = this.querySelector('.top-report-menu[data-case_id="' + activeCaseID + '"] a.print-report-btn');
                if (printBtn) {
                    if (activeAiReport) {
                        printBtn.style.display = "block";
                        if (activeAiReport.dataset.report_id === 'consolidated') {
                            printBtn.href = activeAiReport.dataset.crypted_report_url + '?report_access_source_id=3';
                        } else {
                            printBtn.href = `/ca/do/u?f=${activeAiReport.dataset.report_id}&type=pdf&report_access_source_id=3`;
                        }
                    } else {
                        printBtn.href = "#";
                        printBtn.style.display = "none";
                    }
                }
            }
        } else {
            const topReportMenu = this.querySelector('.top-report-menu.active');
            if (topReportMenu) {
                const printBtn = topReportMenu.querySelector('a.print-report-btn');
                if (printBtn) {
                    printBtn.href = "#";
                    printBtn.style.display = "none";
                }
            }
        }
    }

    loadEventHandlers()
    {
        const navToggles = this.querySelectorAll('a.nav-top-item');
        navToggles.forEach(elem => {
            elem.addEventListener('mouseover', this.toggleMenu.bind(this));

            elem.addEventListener('mouseleave', this.mouseLeaveMenu.bind(this));
            const parent = elem.closest('li.nav-top');
            const navDropdownList = parent.querySelector('ul.nav-dropdown-list');
            if (navDropdownList) {
                navDropdownList.addEventListener('mouseleave', this.mouseLeaveMenu);
            }
        });

        const navItems = this.querySelectorAll('li.nav-item');
        navItems.forEach(element => {
            element.addEventListener('click', this.reportSelected.bind(this));
            
        });

        document.addEventListener('study-selector-change-event', this.studySelectorChange.bind(this));

        if (this.dataset.initial_document_id > 0) {
            const report_id = this.dataset.initial_document_id;
            const navItem = this.querySelector("li.nav-item[data-report_id='" + report_id + "']");
            if (navItem) {
                this.setInitialAiReport(navItem);
            }
        }

        const psButtons = this.querySelectorAll('.ps-link');
        psButtons.forEach(psButton => {
            psButton.addEventListener('click', this.perfectShotButtonClicked.bind(this));
        });

        // VETALL-26979: arriving from a Perfect Shot entry point (worklist chip, perfectshot=1)
        if (this.dataset.perfect_shot_open == 1) {
            const psLink = this.querySelector('ul.top-report-menu.active .ps-link');
            if (psLink) {
                this.setInitialAiReport(psLink);
            }
        }
    }

    setInitialAiReport(navItem)
    {
        const mutationObserver = new MutationObserver((mutations) => {
            const mutation = mutations[0];
            if (mutation.attributeName === 'class') {
                const prevClassList = mutation.oldValue;
                if (!prevClassList) {
                    return;
                }
                if (prevClassList.includes('load_pending') && !mutation.target.classList.contains('load_pending')) {
                    // disconnect the observer
                    mutationObserver.disconnect();
                    // the loader is hidden, we can now change the report
                    setTimeout(() => {
                        navItem.click();
                    }, 500);
                }
            }
        });

        mutationObserver.observe(document.body, {
            attributes: true,
            attributeOldValue: true,
            attributeFilter: ['class'],
            subtree: false
        });


    }

    toggleMenu(event)
    {
        const target = event.target;
        const parent = target.closest('li.nav-top');
        const dropdownList = parent.querySelector('ul.nav-dropdown-list');
        if (dropdownList && !dropdownList.classList.contains('show')) {
            dropdownList.classList.add('show');
        }
    }

    mouseLeaveMenu(event)
    {
        const target = event.target;
        const parent = target.closest('li.nav-top');
        const dropdownList = parent.querySelector('ul.nav-dropdown-list');
        setTimeout(() => {
            if (!parent.matches(':hover')) {
                const dropdownList = parent.querySelector('ul.nav-dropdown-list');
                if (dropdownList) {
                    dropdownList.classList.remove('show');
                    dropdownList.addEventListener('transitionend', function transitionEndHandler() {
                        dropdownList.removeEventListener('transitionend', transitionEndHandler);
                    });
                }
            }
        }, 300);
    }

    perfectShotButtonClicked(event) {
        event.preventDefault();
        const navItem = event.currentTarget;
        const menuRow = navItem.closest('ul.top-report-menu');
        const caseID = menuRow.dataset.case_id;

        const psPane = this.querySelector(".perfect-shot-pane[data-case_id='" + caseID + "']");
        if (psPane) {
            // fade out current page, and fade in new page
            const psPage = psPane.querySelector('.nav-sub-pane');
            const currentPage = this.querySelector("div.nav-sub-pane.active");
            if (currentPage && currentPage != psPage) {
                const currentTabPane = currentPage.closest('.nav-pane');
                const currentReportsContainer = currentPage.closest('.reports-container');
                currentTabPane.style['display'] = 'block';
                if (currentReportsContainer) {
                    currentReportsContainer.style['display'] = 'block';
                }
                currentPage.style['display'] = 'block';
                currentTabPane.addEventListener('transitionend', function transitionEndHandler() {
                    currentTabPane.removeEventListener('transitionend', transitionEndHandler);
                    currentPage.style['display'] = 'none';
                    currentTabPane.style['display'] = 'none';
                    if (currentReportsContainer) {
                        currentReportsContainer.style['display'] = 'none';
                    }
                    psPane.style['display'] = 'block';
                    const printBtn = menuRow.querySelector('a.print-report-btn');
                    if (printBtn) {
                        printBtn.href = "#";
                        printBtn.style.display = "none";
                    }
                    setTimeout(() => {
                        psPage.classList.add('active');
                        psPage.style['display'] = 'block';
                        psPane.querySelector('perfect-shot-image-manager-pane')?.scrollToViewing();
                    }, 100)
                });

                setTimeout(() => {
                    currentPage.classList.remove('active');
                }, 100);
            }
        }
    }

    reportSelected(event)
    {
        const navItem = event.currentTarget;
        const menuRow = navItem.closest('ul.top-report-menu');
        const caseID = menuRow.dataset.case_id;
        const report_id = navItem.dataset.report_id;
        const cryptedReportUrl = navItem.dataset.crypted_report_url || null;

        if (report_id != 0) {
            const newPage = this.querySelector("div[data-report_id='" + report_id + "'][data-case_id='" + caseID + "']");
            if (newPage) {
                // fade out current page, and fade in new page
                const newPageTabPane = newPage.closest('.nav-pane');
                const reportsContainer = newPage.closest('.reports-container');
                const currentPage = this.querySelector("div.nav-sub-pane.active");
                if (currentPage && currentPage != newPage) {
                    const currentTabPane = currentPage.closest('.nav-pane');
                    const currentReportsContainer = currentPage.closest('.reports-container');
                    const dropdownList = navItem.closest('ul.nav-dropdown-list');
                    currentTabPane.style['display'] = 'block';
                    if (currentReportsContainer) {
                        currentReportsContainer.style['display'] = 'block';
                    }
                    currentPage.style['display'] = 'block';
                    currentTabPane.addEventListener('transitionend', function transitionEndHandler() {
                        currentTabPane.removeEventListener('transitionend', transitionEndHandler);
                        currentPage.style['display'] = 'none';
                        currentTabPane.style['display'] = 'none';
                        if (currentReportsContainer) {
                            currentReportsContainer.style['display'] = 'none';
                        }
                        newPage.style['display'] = 'block';
                        newPageTabPane.style['display'] = 'block';
                        if (reportsContainer) {
                            reportsContainer.style['display'] = 'block';
                        }
                        setTimeout(() => {
                            newPage.classList.add('active');
                        }, 100)
                    });

                    setTimeout(() => {
                        currentPage.classList.remove('active');
                    }, 100);

                    dropdownList.classList.remove('show');
                }

                // send a report viewed notification
                if (report_id > 0) {
                    // rad report or AI report
                    const isAiReport = newPage.classList.contains("ai-report");
                    this.sendReportViewedNotification(report_id, isAiReport);
                }
            }
        } 
        // give time for the new report to load before setting print button state
        setTimeout(() => {
            this.setPrintButtonStateForSelectedReport(report_id, caseID, cryptedReportUrl);
        }, 1000);
    }

    setPrintButtonStateForSelectedReport(report_id, caseID, cryptedReportUrl)
    {
    const activePage = this.querySelector("div.nav-sub-pane.active")

        const printBtn = this.querySelector('.top-report-menu[data-case_id="' + caseID + '"] a.print-report-btn');  
        if (printBtn) {
            if (report_id === 'consolidated') {
                printBtn.style.display = 'block';
                printBtn.href = cryptedReportUrl + '?report_access_source_id=3';
            } else if (report_id > 0) {
                if (activePage.classList.contains('ai-report')) {
                    printBtn.href = `/ca/do/u?f=${report_id}&type=pdf&report_access_source_id=3`;
                    printBtn.style.display = 'block';
                } else {
                    const reportLink = activePage.dataset.report_link;
                    printBtn.href = reportLink;
                    printBtn.style.display = 'block';
                }
            } else {
                printBtn.href = '#';
                printBtn.style.display = 'none';
            }
        }
    }

    sendReportViewedNotification(reportID, isAiReport)
    {
        const url = '/patient-manager/report-viewed';
        const formData = new FormData();
        if (isAiReport) {
            formData.append('caseDocID', reportID);
        } else {
            formData.append('caseReportID', reportID);
        }
        formData.append('report_access_source_id', 3);
   
        fetch(url, {
            method: 'post',
            body: formData
        }).then(response => {
            if (!response.ok) {
                console.error('Could not update report viewed status');
            } else {
                return response.json();
            }
        }).then(data => {
            if (!data.success) {
                console.error('Could not update report viewed status');
            } else {
                console.log('Report viewed status updated');
            }
        });
    }

    studySelectorChange(event)
    {
        const target = event.detail.originalEvent.currentTarget;
        const selectedOption = target.querySelector('option:checked');
        if (selectedOption) {
            const caseID = selectedOption.dataset.case_id;

            const reportTopMenus = this.querySelector('nav.workarea-top-menu');
            const newReportMenu = reportTopMenus.querySelector("ul.top-report-menu[data-case_id='" + caseID + "']");
            const currentReportMenu = reportTopMenus.querySelector("ul.top-report-menu.active");
            const currentSubPane = this.querySelector('.nav-sub-pane.active');
            const currentNavPane = currentSubPane.closest('.nav-pane');
            
            const currentReportsContainer = currentSubPane.closest('.reports-container');
            let newActiveReportsPane = this.querySelector('.reports-container[data-case_id="' + caseID + '"]');
            let newActiveSubPane = null;
            if (newActiveReportsPane) {
                // find first subpane with a valid report id
                newActiveSubPane = newActiveReportsPane.querySelector('.nav-sub-pane[data-report_id]:not([data-report_id="0"])');
            }

            if (!newActiveSubPane) {
                newActiveSubPane = this.querySelector('.nav-sub-pane.patient-information.patient-info-case-' + caseID);
            }
            const newNavPane = newActiveSubPane.closest('.nav-pane');
            const newReportsContainer = newActiveSubPane.closest('.reports-container');

            if (newReportMenu && currentReportMenu && currentSubPane && newActiveSubPane) {
                currentReportMenu.classList.remove('active');
                currentSubPane.classList.remove('active');
                currentNavPane.style['display'] = 'none';
                if (currentReportsContainer) {
                    currentReportsContainer.style['display'] = 'none';
                }
                currentSubPane.style['display'] = 'none';

                newReportMenu.classList.add('active');
                newActiveSubPane.classList.add('active');
                newNavPane.style['display'] = 'block';
                if (newReportsContainer) {
                    newReportsContainer.style['display'] = 'block';
                }
                newActiveSubPane.style['display'] = 'block';
            }

            this.setPrintButtonState();
        }
    }
 
}

customElements.define('reporting-workarea', ReportingWorkarea);